import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useReactForm } from "../react-hook/use-react-form";
import { IconRender } from "@/components/shared/Icon-render";
import { CountryInput, SelectWithSearch } from "@/components/form-input";
import { Switch } from "@/components/ui/switch";
import { GenericType } from "@/types";
import { RequiredInput } from "@/components/shared/required-input";

type UserFormType = {
  formData: GenericType;
  onOpenChange: (prop: GenericType) => void;
  onFormSubmit: (prop: boolean) => Promise<void>;
  open: boolean;
  companyList: GenericType[];
};
export const ReactForm = ({
  formData,
  onOpenChange,
  onFormSubmit,
  open,
  companyList,
}: UserFormType) => {
  const { form, onSubmit } = useReactForm({
    formData,
    onOpenChange,
    onFormSubmit,
    open,
  });

  return (
    <>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="grid grid-cols-2 gap-x-6 gap-y-5 px-6">
            <FormField
              control={form.control}
              name="company_id"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    Company id
                    <RequiredInput />
                  </FormLabel>
                  <FormControl>
                    <Input
                      autoComplete="off"
                      placeholder="Company id"
                      {...field}
                      disabled={formData ? true : false}
                    />
                  </FormControl>

                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="display_name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    Display name
                    <RequiredInput />
                  </FormLabel>
                  <FormControl>
                    <Input placeholder="Display name" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="snc_company_id"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Snc company id</FormLabel>
                  <FormControl>
                    <SelectWithSearch
                      options={companyList}
                      value={field.value}
                      onChange={field.onChange}
                      onBlur={field.onBlur}
                      placeholder="Snc company id"
                      bindLabel="label"
                      bindValue="value"
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="country"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Country</FormLabel>
                  <FormControl>
                    <CountryInput
                      placeholder="Select Country"
                      value={field.value}
                      onChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="show_deleted_documents"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Show deleted documents</FormLabel>
                  <FormControl>
                    <div className="flex h-9 items-center">
                      <Switch
                        checked={field.value ?? false}
                        onCheckedChange={field.onChange}
                      />
                    </div>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <hr className="mt-5" />
          <DialogFooter className="p-6 flex !justify-start">
            <Button
              type="submit"
              className="w-[150px]"
              disabled={form.formState.isSubmitting}
            >
              {form.formState.isSubmitting ? (
                <IconRender
                  name="LoaderCircle"
                  className="w-5 animate-spin text-white zoom-in-150"
                />
              ) : (
                "Save"
              )}
            </Button>
            <Button
              type="submit"
              onClick={() => onOpenChange(false)}
              variant={"outline"}
              className="w-[150px]"
            >
              Close
            </Button>
          </DialogFooter>
        </form>
      </Form>
    </>
  );
};
